export default function() {
    return {
        openProfiles: {
            casting: null,
            event_support: null,
            bars_restaurants: null,
            master_of_ceremonies: null
        },
        completedCourseDetails: {
            show: false,
            image: null,
            name: null,
            description: null
        }
    }
}
